module.exports = __webpack_public_path__ + "img/rks-icon.77f19250.png";